import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { PayloadProps } from "../../core/schema";
import { getLocalStorage } from "../../core/localStorageService";
import apiEndpoint from "../../core/apiend_point";
import { triggerApi } from "../../services";
import BackSecion from "../common/header";
import { Spinner } from "react-bootstrap";
import "./attendance.css";
import "react-date-picker/dist/DatePicker.css";
import forward_arrow from "../../assets/images/forward_arrow.png";
import back_arrow from "../../assets/images/back_arrow.png";
// import moment from "moment";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import 'react-calendar/dist/Calendar.css';

const allmonths = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

/**
 * Renders Component.
 * @return {StudentAttendance} renders Component.
 */
export default function StudentAttendace() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [events, setEvents] = useState<any[]>([]);
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState<any>();
  const [monthIndex, setMonthIndex] = useState(new Date().getMonth());
  useEffect(() => {
    onDateChange(new Date());
    // let m = getMonthBefore();
    // console.log(m, month)
  }, []);

  useEffect(() => {
    month && getStudentAttendance();
    // alert(month)
  }, [month]);

  async function getMonthBefore(increment: string) {
    var mon = month;
    var y = year;
    if (increment === "inc") {
      // let m = month === 11 ? 0 : month + 1;

      // mon = "0"+(m+1);
      // y = month === 11 ? year + 1 : year;
      // console.log(month, m)
      month > 11 && setYear(year + 1);
      setMonthIndex((m: number) => (m === 11 ? 0 : month));
      setMonth((m: number) => (month > 11 ? 1 : m + 1));
    } else if (increment === "dec") {
      // let m = month === 0 ? 11 : month - 1;

      // mon = "0"+(m-1);
      // y = month === 0 ? year - 1 : year;
      month === 1 && setYear(year - 1);
      setMonthIndex((m: number) => (m === 0 ? 11 : m - 1));
      setMonth((m: number) => (month === 1 ? 12 : m - 1));
    }
    // console.log(year, m)
  }

  const getStudentAttendance = () => {
    setIsLoading(true);
    const user: any = JSON.parse(getLocalStorage("user") ?? "");
    let userId = user?.student[0]?.user_id;
    let userSectionId = user?.student[0]?.section_id;
    let userType = 1;
    const d = new Date();
    let mon = month === 0 ? 12 : month;
    let m = mon > 9 ? mon : "0" + mon;
    let date = `${m}-${year}`; //d.getMonth() + 1;
    // const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    // const d = new Date();
    // let name = month[d.getMonth()];
    const apiObject: PayloadProps = {
      payload: {
        auth_token: getLocalStorage("token"),
        user_id: user?.student[0]?.user_id,
        mobile: user?.student[0]?.mobile,
      },
      method: "GET",
      apiUrl:
        apiEndpoint.userAttendance +
        "/" +
        userType +
        "/" +
        userId +
        "/" +
        `${date}` +
        "/" +
        userSectionId,
    };

    triggerApi(apiObject)
      .then((res: any) => {
        if (res.attendance) {
          setData(res.attendance);
          let newEvents:any =[];
          res.attendance.P && res.attendance.P.forEach((item:any, index:number) =>{
            item && newEvents.push({ title: "Present", start: item, backgroundColor: "green" })
          });
          res.attendance.A && res.attendance.A.forEach((item:any, index:number) =>{
            item && newEvents.push({ title: "Absent", start: item, backgroundColor: "red" })
          });
          res.attendance.H && res.attendance.H.forEach((item:any, index:number) =>{
            item && newEvents.push({ title: "Holiday", start: item, backgroundColor: "yeallow" })
          });
          console.log(newEvents)
          setEvents(newEvents)
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  function eventFunction(item:any, index:number) {
    // text += index + ": " + item + "<br>"; 
    let existingEvents:any ={};

    existingEvents.push({ title: "Present", start: item, backgroundColor: "green" })
    // console.log(existingEvents)
    
  }

  // const events = [
  //   { title: "Present", start: "2023-05-22", backgroundColor: "green" },
  //   { title: "Absent", start: "2023-05-02", backgroundColor: "red" },
  //   { title: "Present", start: "2023-05-12", backgroundColor: "green" },
  // ];

  function getDate(dayString: string) {
    const today = new Date();
    const year = today.getFullYear().toString();
    let month = (today.getMonth() + 1).toString();

    if (month.length === 1) {
      month = "0" + month;
    }
    console.log(dayString.replace("YEAR", year).replace("MONTH", month));
    return dayString.replace("YEAR", year).replace("MONTH", month);
  }

  function renderEventContent(eventInfo: any) {
    return (
      <>
        <span>{eventInfo.event.title}</span>
      </>
    );
  }

  function onDateChange(date: any) {
    const y = date.getFullYear();
    setYear(y);
    let m = date.getMonth() + 1;
    setMonth(m);
    // console.log(year, m)
    // getStudentAttendance();
  }

  return (
    <>
      <div className="cmmn px-3">
        <Container className="d-flex flex-column height_100vh">
          <BackSecion name="Attendance" navigate_action="/home" />
          <Row className="mt-2">
            <Col xs={3} className="m-auto fee_gry rounded-3 p-3 cursor text-center">
            <img
            src={back_arrow}
            alt="Previous"
            width="10px"
            height="17px"
            className="d-inline"
            onClick={() => getMonthBefore("dec")}
          />
            </Col>
            <Col xs={6} className="m-auto fee_gry rounded-3 p-3 text-center fs-2">{allmonths[monthIndex]} - {year}</Col>
            <Col xs={3} className="m-auto fee_gry rounded-3 p-3 cursor text-center">
            <img
            src={forward_arrow}
            alt="Previous"
            width="10px"
            height="17px"
            className="d-inline"
            onClick={() => getMonthBefore("inc")}
          />
            </Col>
          </Row>
          
          
          
          {isLoading && (
            <div className="loader">
              <Spinner animation="border" variant="primary" />
            </div>
          )}
          {!isLoading && year && month && (
            // <Row className="mt-4">
            <FullCalendar
            height={'600px'}
              plugins={[dayGridPlugin]}
              initialView="dayGridMonth"
              events={events}
              eventContent={renderEventContent}
              firstDay={1}
              themeSystem="Simplex"
              // headerToolbar={false}
              headerToolbar={{
                left: "", //prev
                center: "", //title
                right: "", //next
              }}
              // hiddenDays={}
              initialDate={new Date(year, month-1)}
            />
            // </Row>
          )}
        </Container>
      </div>
    </>
  );
}
